"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ButtonPlay = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const SimpleButton_1 = tslib_1.__importDefault(require("../../../components/SimpleButton"));
const StringExtensions_1 = tslib_1.__importDefault(require("../../../Utilities/Extensions/StringExtensions"));
class ButtonPlay extends React.Component {
    render() {
        return (React.createElement(SimpleButton_1.default, Object.assign({ "data-name": "play", tooltip: StringExtensions_1.default.IsNullOrEmpty(this.props.tooltip) ? 'Play' : this.props.tooltip, iconSize: 20, icon: "play", variant: "text" }, this.props)));
    }
}
exports.ButtonPlay = ButtonPlay;
